export default __webpack_public_path__ + "static/media/afternoon.84392319.svg";